import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
import * as actions from '../../../../services/actions';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from '../../ProfilGraphe/FormulaireGraphe/FormulaireGraphe.module.scss';
import stylesD from './ChangementEchantillonGraphe.module.scss';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';

import FormulaireSelectionDateHeureUnix from '../../ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';
import FormulaireSelectUtsDate from '../../ProfilGraphe/FormulaireGraphe/FormulaireSelectUtsDate/FormulaireSelectUtsDate';
import FormulaireSaisieDuree from '../../../UI/FormulaireSaisieDurée/FormulaireSaisieDuree';
import Bouton from '../../../UI/Bouton/Bouton';
import HoverButton from '../../../UI/BoutonHover/BoutonHover';

import { integerOrNull } from '../../../../ressources/functionJS/integerOrNull';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import help from '../../../../ressources/imgStatic/N_temp.gif';
import helpB from '../../../../ressources/imgStatic/n_line.gif';

const ChangementEchantillonGraphe = ({
  afficherPopup,
  fermerPopupModifierIntervalle,
  affichageProfil,
  graph_id,
  changementEchantillonObjetGrapheVue,
}) => {
  // Separate state hooks
  const [timeInterval, setTimeInterval] = useState([null, null]);
  const [timePeriod, setTimePeriod] = useState(null);
  const [measuresNum, setMeasuresNum] = useState(null);
  const [selectTime, setSelectTime] = useState([]);
  const [modalStyle, setModalStyle] = useState({
    inset: '15% 10% 1% 30%',
    width: '45%',
    height: '65%',
  });

  const dispatch = useDispatch();

  // Screen size effect
  useEffect(() => {
    if (
      window.screen.availWidth / 2 >= window.innerWidth ||
      window.screen.availHeight / 2 >= window.outerHeight
    ) {
      setModalStyle({
        inset: '0 0 0 0',
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
  }, []);

  // Event handlers
  const handleStartTimeInterval = (unix) => {
    setTimeInterval((prev) => [unix, prev[1]]);
  };

  const handleEndTimeInterval = (unix) => {
    setTimeInterval((prev) => [prev[0], unix]);
  };

  const handleTimePeriod = (period) => {
    setTimePeriod(period);
  };

  const handleMeasuresNum = (event) => {
    setMeasuresNum(event.target.value);
  };

  const handleSelectTime = (newConfig) => {
    setSelectTime([...newConfig]);
  };

  const handleSubmit = () => {
    dispatch(
      actions.reqRecupererDonneesGraphe(
        integerOrNull(graph_id),
        integerOrNull(timePeriod),
        integerOrNull(measuresNum),
        selectTime,
        timeInterval
      )
    );

    if (typeof changementEchantillonObjetGrapheVue === 'function') {
      changementEchantillonObjetGrapheVue();
    }
  };
  return (
    <div>
      <Modal
        isOpen={afficherPopup}
        style={{
          overlay: {
            position: 'absolute',
            zIndex: '1000',
            overflowX: 'hidden',
            overflowY: 'hidden',
            border: 'black 1px solid',
            backgroundColor: 'transparent',
            transition: 'width 2s, height 4s',
          },
          content: {
            padding: '0px',
            overflowX: 'auto',
            width: modalStyle.width,
            height: modalStyle.height,
            inset: modalStyle.inset,
            boxShadow: '-5px 0px 5px rgba(0, 0, 0, 0.226)',
          },
        }}
        className={stylesD.ModalAdv}
        overlayClassName={stylesD.OverlayAdv}
        onRequestClose={fermerPopupModifierIntervalle}
      >
        <div className={[s.card_header, s.text_right].join(' ')}>
          <Bouton
            type={type_btn.fermer}
            rond={true}
            cliquer={fermerPopupModifierIntervalle}
          />
        </div>
        <div className={[styles.container, styles.Formulaire].join(' ')}>
          {/* Time Interval Section */}
          <div className={s.form_group}>
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <span className={s.col_12}>
                {checkMot('Interval de récupération de données [début, fin]')}
              </span>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={timeInterval[0]}
                  gereUnixDate={handleStartTimeInterval}
                  disabled={affichageProfil}
                />
              </div>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={timeInterval[1]}
                  gereUnixDate={handleEndTimeInterval}
                  disabled={affichageProfil}
                />
              </div>
            </div>
          </div>

          <div className={s.form_group}>
            {/**DEBUT time_period**/}
            <div className={s.form_row}>
              <div className={s.col_12}>
                <span>
                  {checkMot(
                    'recuperation_des_donnees_sur_le_dernier_interval_de_temps_jusqu_a_present'
                  )}{' '}
                </span>{' '}
                <HoverButton customClass={styles.sstyle} imageUrl={help} />
                <FormulaireSaisieDuree
                  affichageProfil={affichageProfil}
                  gererDuree={handleTimePeriod}
                  preconfigurerDuree={timePeriod}
                />
              </div>
            </div>
          </div>
          {/**FIN time_period**/}
          <div className={s.form_group}>
            {/**DEBUT measures_num**/}
            <div className={s.form_row}>
              <div className={s.col_12}>
                <span>
                  {checkMot(
                    'recuperation_des_n_derniere_donnees_jusqu_a_present'
                  )}{' '}
                </span>{' '}
                <HoverButton customClass={styles.sstyle} imageUrl={helpB} />
                <input
                  type="text"
                  pattern="[0-9]+"
                  className={[s.form_control, s.mb_2].join(' ')}
                  placeholder="measures_num"
                  name="measures_num"
                  value={measuresNum}
                  disabled={affichageProfil === true}
                  required
                  onChange={(event) => handleMeasuresNum(event)}
                />
              </div>
            </div>
          </div>
          {/**FIN measures_num**/}
          <div className={s.form_group}>
            {/**DEBUT select_time**/}
            <div className={s.form_row}>
              <div className={s.col_12}>
                <span>
                  {checkMot('recuperation_des_donnees_des_dates_selectionnees')}
                </span>
                <FormulaireSelectUtsDate
                  preConfigSelectUtsDate={selectTime}
                  gererConfigSelectUtsDate={handleSelectTime}
                  disabled={affichageProfil === true}
                />
              </div>
            </div>
          </div>
          {/**FIN select_time**/}

          <Bouton
            cliquer={() => {
              handleSubmit();
              if (changementEchantillonObjetGrapheVue instanceof Function) {
                changementEchantillonObjetGrapheVue();
              }
            }}
          >
            {checkMot('changer_d_echantillon')}
          </Bouton>
        </div>
      </Modal>
    </div>
  );
};

export default ChangementEchantillonGraphe;
